// extracted by mini-css-extract-plugin
export default {"w-full":"Table_w-full__Qrkwt","wrapper":"Table_wrapper__sujT9","table":"Table_table__ulI6v","row":"Table_row__p7Bhv","col":"Table_col__HrpwA","status":"Table_status__ytg7P"};